import { OnInit, ElementRef, Input, Directive } from '@angular/core';

@Directive({ selector: '[focusMe]' })
export class FocusDirective implements OnInit {

    @Input('focusMe') isFocused: boolean;
    @Input('selectMe') isSelected: boolean;

    constructor(private hostElement: ElementRef) { }

    ngOnInit() {
        if (this.isFocused) {
            //this.renderer.invokeElementMethod(this.hostElement.nativeElement, 'focus');
            (this.hostElement.nativeElement as any)['focus'].apply(this.hostElement.nativeElement);
        }
        if (this.isSelected) {
            //this.renderer.invokeElementMethod(this.hostElement.nativeElement, 'select');
            (this.hostElement.nativeElement as any)['select'].apply(this.hostElement.nativeElement);
        }
    }
}
